import {
	AdminShell,
	AdminSidebar,
	AdminTopbar,
} from "@vantage-hub/ui";
import type { NavSection } from "@vantage-hub/ui";
import { type ReactNode, useEffect, useState } from "react";
import {
	BarChart2Icon,
	FileBarChartIcon,
	FileTextIcon,
	LayoutDashboardIcon,
	RefreshCwIcon,
	SettingsIcon,
	UsersIcon,
} from "lucide-react";

function buildNavSections(activeId: string): NavSection[] {
	return [
		{
			label: "Workspace",
			items: [
				{
					id: "overview",
					label: "Overview",
					icon: LayoutDashboardIcon,
					href: "/",
					active: activeId === "overview",
				},
				{
					id: "certificates",
					label: "Certificates",
					icon: FileTextIcon,
					href: "/certificates",
					count: 1284,
					active: activeId === "certificates",
				},
				{
					id: "renewals",
					label: "Renewals",
					icon: RefreshCwIcon,
					href: "/renewals",
					count: 42,
					active: activeId === "renewals",
				},
			],
		},
		{
			label: "Insights",
			items: [
				{
					id: "analytics",
					label: "Analytics",
					icon: BarChart2Icon,
					href: "/analytics",
					badge: "NEW",
					active: activeId === "analytics",
				},
				{
					id: "reports",
					label: "Reports",
					icon: FileBarChartIcon,
					href: "/reports",
					active: activeId === "reports",
				},
			],
		},
		{
			label: "Administration",
			items: [
				{
					id: "team",
					label: "Team",
					icon: UsersIcon,
					href: "/team",
					active: activeId === "team",
				},
				{
					id: "settings",
					label: "Settings",
					icon: SettingsIcon,
					href: "/settings",
					active: activeId === "settings",
				},
			],
		},
	];
}

interface PortalShellProps {
	activeId: string;
	pageTitle: string;
	children: ReactNode;
}

export function PortalShell({ activeId, pageTitle, children }: PortalShellProps) {
	const [isDark, setIsDark] = useState(
		() =>
			document.documentElement.getAttribute("data-theme") === "dark" ||
			(!document.documentElement.hasAttribute("data-theme") &&
				window.matchMedia("(prefers-color-scheme: dark)").matches),
	);

	useEffect(() => {
		document.documentElement.setAttribute("data-theme", isDark ? "dark" : "light");
	}, [isDark]);

	const breadcrumbs = [
		{ label: "Brinks", href: "/" },
		{ label: "Certificate Portal", href: "/" },
		{ label: pageTitle },
	];

	return (
		<AdminShell
			sidebar={
				<AdminSidebar
					brandName="Brinks"
					brandSub="Certificate Portal"
					brandMark="B"
					brandLogoUrl="/brinks-logo-blue.png"
					navSections={buildNavSections(activeId)}
					workspaceName="Brinks Security — UK"
					workspacePlan="Enterprise · 140 seats"
					workspaceInitials="BS"
				/>
			}
			topbar={
				<AdminTopbar
					breadcrumbs={breadcrumbs}
					searchPlaceholder="Search certificates, programs, renewals…"
					periodLabel="Q1 2026"
					userInitials="EL"
					userName="Elena Lindqvist"
					userRole="Head of Compliance"
					notificationCount={3}
					isDark={isDark}
					onToggleTheme={() => setIsDark((d) => !d)}
				/>
			}
		>
			{children}
		</AdminShell>
	);
}
